import config from '../config/config';

export const handleContactProvider = (email) => {
  window.location.href = `mailto:${email}`;
};

/**
 * Normalized deployment environment from `REACT_APP_ENVIRONMENT`.
 * Defaults to `dev` when unset so local development behaves like a non-prod environment.
 */
export function getEnvironment() {
  return String(config.environment || 'dev').trim().toLowerCase();
}

